module.exports = __webpack_public_path__ + "assets/media/arrow.380422cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/CustomMessage/arrow.svg
// module id = 2110
// module chunks = 0